import * as React from 'react';
import { reduxForm } from 'redux-form';
import { get } from 'lodash';
import { compose, mapProps, withProps } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { InputField, Input } from '@components/form';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

import { getJobRun } from '@modules/jobs/_jobsActions';
import * as T from '@modules/jobs/_jobsTypes';

const enhance = compose<any, any>(
  mapProps(({ jobId, ...rest }) => ({ injectedGetEntityProps: jobId, ...rest })),
  EntityDetailEnhancer<any, any>({
    getEntity: getJobRun,
    defaultEntity: {}
  }),
  withProps<{}, T.JobsForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({})
);

const View = ({ closeItem }) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>
    {[
      {
        name: 'result',
        label: 'Výsledek'
      },
      {
        name: 'console',
        label: 'Konzole',
        multiline: true
      }
    ].map(field => (
      <Col md={12} key={field.name}>
        <InputField component={Input} disabled={true} {...field} />
      </Col>
    ))}
    <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
  </Grid>
);

export const JobRunsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/jobs/JobRunsForm.tsx